var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_1560_9442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99187 11.8969L13.0728 8.5674C13.8705 8.22058 16.5757 7.11075 16.5757 7.11075C16.5757 7.11075 17.8242 6.6252 17.7202 7.80439C17.6855 8.28994 17.4081 9.98936 17.1306 11.8275L16.2635 17.2726C16.2635 17.2726 16.1942 18.0703 15.6046 18.209C15.015 18.3477 14.0439 17.7235 13.8705 17.5847C13.7318 17.4807 11.2693 15.92 10.3676 15.157C10.1248 14.9489 9.84736 14.5327 10.4023 14.0472C11.6508 12.9027 13.1422 11.4807 14.0439 10.579C14.4601 10.1628 14.8763 9.19167 13.1422 10.3709L8.25198 13.6657C8.25198 13.6657 7.69707 14.0125 6.65661 13.7003C5.61614 13.3882 4.40227 12.972 4.40227 12.972C4.40227 12.972 3.5699 12.4518 4.99187 11.8969Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1560_9442",
    x1: 16.0009,
    y1: 4.00092,
    x2: 10.0009,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.95b4eab5be0cd512cf5dcaac2ec6b371.svg";
export { ForwardRef as ReactComponent };